import { z } from "zod";

import { SnackInputSchema } from "@/lib/zod/__generated__/validation-schema";

import { slugZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

export const snackInputZodSchema = SnackInputSchema.extend({
	title: z.string().min(1).max(50),
	description: z.string().max(500).nullish(),
	thumbnail: z.string().min(1, { message: "サムネイルは入力必須項目です" }),
	slug: slugZodSchema.nullish().or(z.literal("")),
});

export type SnackZodSchemaType = z.infer<typeof snackInputZodSchema>;
